import universalDesign from './universalDesign';
export const systemThemes = [universalDesign];
export const defaultThemeOptions = universalDesign; // Default fonts for the app
// Used as a fallback when no fonts are loaded

export const defaultFonts = universalDesign.fonts;
export const WIDGETS_THEME_BLACK_LIST = ['notion'];
export const PREVIEW_BASE_URL = `https://graphitup.b-cdn.net/themes`;
export const SYSTEM_THEME_ID = 'universal-design';
export const SYSTEM_THEME_NAME = 'Default';